// Ajustar o componente AddUserToDepartmentModal para funcionar com Departamento

import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import UsersSearch from "../dashboard/calender/UsersSearch";
import ApiService from "../util/ApiService";

const AddUserToDepartmentModal = ({ show, onHide, department, onSuccess }) => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleAddUser = async () => {
        if (!selectedUser?.value) {
            Swal.fire("Atenção", "Selecione um usuário antes de adicionar.", "warning");
            return;
        }

        setLoading(true);
        try {
            const params = {
                department_id: department?.id,
                user_id: selectedUser.value
            };
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/register-user`,
                params,
                true
            );

            if (response.code === 200) {
                Swal.fire("Sucesso", "Usuário adicionado ao departamento!", "success");
                onSuccess?.();
                setSelectedUser(null);
                onHide();
            } else {
                Swal.fire("Erro", "Erro ao adicionar o usuário.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Adicionar Usuário ao Departamento</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Nome: <strong>{department?.name}</strong>
                </p>
                <UsersSearch onUserSelect={setSelectedUser} />
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={onHide} disabled={loading}>Cancelar</button>
                <button className="btn btn-success" onClick={handleAddUser} disabled={loading || !selectedUser}>
                    <i className="fa fa-plus"></i> Adicionar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddUserToDepartmentModal;
